import request from '../request';
import querystring from 'querystring';

/**
 * Refactored into template string and added try catch for better implementation possibilities in error handling
 * Also cleaned up with a default argument and check for params or not
 *
 */
export default async function deleteRequest(baseUrl, params = '', body) {
	if (params) params = `?${querystring.stringify(params)}`;
	let url = `${baseUrl}${params}`;
	let response = await request({
		method: 'delete',
		url,
		data: body,
	});
	return response;
}
